import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Close, Info } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import DOMPurify from 'dompurify';
import { FeatureBox } from './styled-components';
export const FeaturesContainer = ({ features, selectedPlan, branding }) => {
    const sanitize = (html) => DOMPurify.sanitize(html, { ALLOWED_TAGS: ['br', 'strike'] });
    return (_jsxs(FeatureBox, { children: [_jsx(Typography, { variant: "h6", sx: {
                    color: branding.textSecondary,
                    mb: 2.5,
                    letterSpacing: '0.05em',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }, children: "FEATURES" }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1.75 }, children: features
                    ?.slice()
                    ?.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                    .map((feature) => {
                    const selectedPlanActiveFeature = selectedPlan?.activeFeatures?.find((af) => af.membershipFeatureId === feature.membershipFeatureId);
                    const isIncluded = selectedPlan?.activeFeatures?.some((activeFeature) => activeFeature.membershipFeatureId === feature.membershipFeatureId);
                    return (_jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1.5,
                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                transform: 'translateX(4px)',
                                '& .icon-circle': {
                                    transform: isIncluded ? 'scale(1.1)' : 'scale(1)',
                                },
                            },
                        }, children: [_jsx(Box, { sx: { mt: 0.25 }, children: _jsx(Box, { className: "icon-circle", sx: {
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: isIncluded ? alpha(branding.primaryColor, 1) : branding.grey300,
                                        transform: isIncluded ? 'scale(1)' : 'scale(0.95)',
                                        transition: 'all 0.3s ease',
                                    }, children: isIncluded ? (_jsx(Check, { sx: { fontSize: 12, color: '#fff' } })) : (_jsx(Close, { sx: { fontSize: 12, color: '#fff' } })) }) }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.75, flex: 1 }, children: [_jsx(Typography, { variant: "body2", sx: {
                                            color: isIncluded ? '#111827' : '#9ca3af',
                                            transition: 'color 0.3s ease',
                                        }, component: "div", dangerouslySetInnerHTML: {
                                            __html: sanitize(selectedPlanActiveFeature?.overrideContent ||
                                                feature.defaultContent ||
                                                ''),
                                        } }), (selectedPlanActiveFeature?.overrideTooltip ?? feature.defaultTooltip) ? (_jsx(Tooltip, { title: _jsx(Box, { sx: { whiteSpace: 'pre-line' }, dangerouslySetInnerHTML: {
                                                __html: sanitize(selectedPlanActiveFeature?.overrideTooltip ||
                                                    feature.defaultTooltip ||
                                                    ''),
                                            } }), placement: "right", arrow: true, children: _jsx(Info, { sx: {
                                                fontSize: 16,
                                                color: '#9ca3af',
                                                cursor: 'help',
                                                transition: 'color 0.2s ease',
                                                '&:hover': { color: '#6b7280' },
                                            } }) })) : null] })] }, feature.membershipFeatureId));
                }) })] }));
};
